import SoftwarePicker from '../../components/software-picker.vue';
import {createVueInstance} from "../../vue-root";

createVueInstance({
    name: 'trial-page',
    components: { 
        SoftwarePicker
    },
});